import { platform, PlatformType } from "../../bud-lite-tv/src/lib";

interface WebOSWindow {
  webOS: {
    service: any;
  };
}

class WebOSManager {
  launchAppFTV() {
    try {
      // Vérifie que l’API webOS est disponible
      if (typeof window.webOS === "undefined") {
        console.error("webOS service not available");
        return;
      }
      const webOS = ((window as unknown) as WebOSWindow).webOS;
      webOS.service.request("luna://com.webos.applicationManager", {
        method: "launch",
        parameters: { id: "com.dotscreen.france-tv-smart-tv" },
        onSuccess: (inResponse: unknown) => {
          console.log("The app is launched");
          Log.app?.log?.("Launch Success: ", JSON.stringify(inResponse));
        },
        onFailure: (inError: any) => {
          console.error("Failed to launch the app");
          Log.app?.error?.("Launch Error: ", JSON.stringify(inError));
        },
      });
    } catch (error) {
      console.error("Launch Exception: ", error);
      Log.app?.error?.("Launch Exception: ", JSON.stringify(error));
    }
  }

  private static _instance?: WebOSManager;

  static get instance() {
    if (platform.type === PlatformType.webos) {
      return (WebOSManager._instance = WebOSManager._instance ?? new WebOSManager());
    } else {
      return undefined;
    }
  }
}

export const WebOSHelper = WebOSManager.instance;
